export const urlcode = 'https://ysapi.sjhlwyy.com'//正式
// export const urlcode = 'http://192.168.40.19:1092/shenpi'  //fqf
localStorage.setItem('urlcode', urlcode);
export default {urlcode}



// WEBPACK FOOTER //
// ./src/config.js